// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/job.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/job.proto.
 */
export const file_travplaces_v1_job: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * Job is one long-running admin pipeline task — an OSM download, a POI /
 * Foursquare import, a Valhalla / OTP / basemap build, or a verify pass.
 *
 * Ported from the legacy TravPlaces import_jobs table + server/src/jobs/*.
 * NOTE: the heavy execution (external tool orchestration) is stubbed here —
 * each Enqueue* RPC only records a job row in status "queued". The real
 * pipeline is infra-gated and lands in a later follow-up.
 *
 * @generated from message travplaces.v1.Job
 */
export type Job = Message<"travplaces.v1.Job"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * empty when the job is not tied to a city
   *
   * @generated from field: string city_id = 2;
   */
  cityId: string;

  /**
   * type: osm_download | poi_import | fsq_import | valhalla_build |
   *       otp_build | basemap_build | verify
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * status: queued | running | succeeded | failed | cancelled | interrupted
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * 0-100
   *
   * @generated from field: int32 progress = 5;
   */
  progress: number;

  /**
   * empty when null — short human-readable status line
   *
   * @generated from field: string message = 6;
   */
  message: string;

  /**
   * accumulated log text
   *
   * @generated from field: string log = 7;
   */
  log: string;

  /**
   * JSON object the task was enqueued with
   *
   * @generated from field: string params = 8;
   */
  params: string;

  /**
   * JSON result, empty when null
   *
   * @generated from field: string result = 9;
   */
  result: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * nil until running
   *
   * @generated from field: google.protobuf.Timestamp started_at = 11;
   */
  startedAt?: Timestamp | undefined;

  /**
   * nil until terminal
   *
   * @generated from field: google.protobuf.Timestamp finished_at = 12;
   */
  finishedAt?: Timestamp | undefined;
};

/**
 * Describes the message travplaces.v1.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema: GenMessage<Job> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 0);

/**
 * @generated from message travplaces.v1.ListJobsRequest
 */
export type ListJobsRequest = Message<"travplaces.v1.ListJobsRequest"> & {
  /**
   * optional — empty lists all cities' jobs
   *
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * defaults to 50 when zero or negative
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message travplaces.v1.ListJobsRequest.
 * Use `create(ListJobsRequestSchema)` to create a new message.
 */
export const ListJobsRequestSchema: GenMessage<ListJobsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 1);

/**
 * @generated from message travplaces.v1.ListJobsResponse
 */
export type ListJobsResponse = Message<"travplaces.v1.ListJobsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Job jobs = 1;
   */
  jobs: Job[];
};

/**
 * Describes the message travplaces.v1.ListJobsResponse.
 * Use `create(ListJobsResponseSchema)` to create a new message.
 */
export const ListJobsResponseSchema: GenMessage<ListJobsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 2);

/**
 * @generated from message travplaces.v1.GetJobRequest
 */
export type GetJobRequest = Message<"travplaces.v1.GetJobRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetJobRequest.
 * Use `create(GetJobRequestSchema)` to create a new message.
 */
export const GetJobRequestSchema: GenMessage<GetJobRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 3);

/**
 * @generated from message travplaces.v1.GetJobResponse
 */
export type GetJobResponse = Message<"travplaces.v1.GetJobResponse"> & {
  /**
   * @generated from field: travplaces.v1.Job job = 1;
   */
  job?: Job | undefined;
};

/**
 * Describes the message travplaces.v1.GetJobResponse.
 * Use `create(GetJobResponseSchema)` to create a new message.
 */
export const GetJobResponseSchema: GenMessage<GetJobResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 4);

/**
 * @generated from message travplaces.v1.CancelJobRequest
 */
export type CancelJobRequest = Message<"travplaces.v1.CancelJobRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.CancelJobRequest.
 * Use `create(CancelJobRequestSchema)` to create a new message.
 */
export const CancelJobRequestSchema: GenMessage<CancelJobRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 5);

/**
 * @generated from message travplaces.v1.CancelJobResponse
 */
export type CancelJobResponse = Message<"travplaces.v1.CancelJobResponse"> & {
  /**
   * @generated from field: travplaces.v1.Job job = 1;
   */
  job?: Job | undefined;
};

/**
 * Describes the message travplaces.v1.CancelJobResponse.
 * Use `create(CancelJobResponseSchema)` to create a new message.
 */
export const CancelJobResponseSchema: GenMessage<CancelJobResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 6);

/**
 * Every Enqueue* RPC returns the freshly-created "queued" job.
 *
 * @generated from message travplaces.v1.EnqueueJobResponse
 */
export type EnqueueJobResponse = Message<"travplaces.v1.EnqueueJobResponse"> & {
  /**
   * @generated from field: travplaces.v1.Job job = 1;
   */
  job?: Job | undefined;
};

/**
 * Describes the message travplaces.v1.EnqueueJobResponse.
 * Use `create(EnqueueJobResponseSchema)` to create a new message.
 */
export const EnqueueJobResponseSchema: GenMessage<EnqueueJobResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 7);

/**
 * @generated from message travplaces.v1.EnqueueImportOsmRequest
 */
export type EnqueueImportOsmRequest = Message<"travplaces.v1.EnqueueImportOsmRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * OSM extract URL (.osm.pbf)
   *
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message travplaces.v1.EnqueueImportOsmRequest.
 * Use `create(EnqueueImportOsmRequestSchema)` to create a new message.
 */
export const EnqueueImportOsmRequestSchema: GenMessage<EnqueueImportOsmRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 8);

/**
 * @generated from message travplaces.v1.EnqueueImportPoisRequest
 */
export type EnqueueImportPoisRequest = Message<"travplaces.v1.EnqueueImportPoisRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * optional subset; empty = all
   *
   * @generated from field: repeated string category_keys = 2;
   */
  categoryKeys: string[];

  /**
   * count only, write nothing
   *
   * @generated from field: bool preview = 3;
   */
  preview: boolean;
};

/**
 * Describes the message travplaces.v1.EnqueueImportPoisRequest.
 * Use `create(EnqueueImportPoisRequestSchema)` to create a new message.
 */
export const EnqueueImportPoisRequestSchema: GenMessage<EnqueueImportPoisRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 9);

/**
 * @generated from message travplaces.v1.EnqueueImportFsqRequest
 */
export type EnqueueImportFsqRequest = Message<"travplaces.v1.EnqueueImportFsqRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.EnqueueImportFsqRequest.
 * Use `create(EnqueueImportFsqRequestSchema)` to create a new message.
 */
export const EnqueueImportFsqRequestSchema: GenMessage<EnqueueImportFsqRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 10);

/**
 * @generated from message travplaces.v1.EnqueueBuildValhallaRequest
 */
export type EnqueueBuildValhallaRequest = Message<"travplaces.v1.EnqueueBuildValhallaRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.EnqueueBuildValhallaRequest.
 * Use `create(EnqueueBuildValhallaRequestSchema)` to create a new message.
 */
export const EnqueueBuildValhallaRequestSchema: GenMessage<EnqueueBuildValhallaRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 11);

/**
 * @generated from message travplaces.v1.EnqueueBuildOtpRequest
 */
export type EnqueueBuildOtpRequest = Message<"travplaces.v1.EnqueueBuildOtpRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.EnqueueBuildOtpRequest.
 * Use `create(EnqueueBuildOtpRequestSchema)` to create a new message.
 */
export const EnqueueBuildOtpRequestSchema: GenMessage<EnqueueBuildOtpRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 12);

/**
 * @generated from message travplaces.v1.EnqueueBuildBasemapRequest
 */
export type EnqueueBuildBasemapRequest = Message<"travplaces.v1.EnqueueBuildBasemapRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * Where to fetch a ready-made archive instead of generating one.
   *
   * Generating is the slow step by a wide margin — a metro area is minutes
   * and the reference data alone is 1.5GB — and the result does not depend on
   * this deployment at all. So an archive built once, anywhere, can be
   * published and pulled: by every environment of the same deployment, or
   * from a provider that sells OpenMapTiles extracts.
   *
   * Must be the OpenMapTiles schema in PMTiles format, which is what the map
   * style reads. Empty means build it here, as before.
   *
   * @generated from field: string archive_url = 2;
   */
  archiveUrl: string;
};

/**
 * Describes the message travplaces.v1.EnqueueBuildBasemapRequest.
 * Use `create(EnqueueBuildBasemapRequestSchema)` to create a new message.
 */
export const EnqueueBuildBasemapRequestSchema: GenMessage<EnqueueBuildBasemapRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 13);

/**
 * @generated from message travplaces.v1.EnqueueVerifyRequest
 */
export type EnqueueVerifyRequest = Message<"travplaces.v1.EnqueueVerifyRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;
};

/**
 * Describes the message travplaces.v1.EnqueueVerifyRequest.
 * Use `create(EnqueueVerifyRequestSchema)` to create a new message.
 */
export const EnqueueVerifyRequestSchema: GenMessage<EnqueueVerifyRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_job, 14);

/**
 * JobService manages the admin import / build pipeline.
 *
 * Execution is stubbed: Enqueue* RPCs insert a "queued" job row and return
 * it. Live progress (SSE streamJob) and GTFS upload are deferred to a
 * follow-up HTTP handler.
 *
 * @generated from service travplaces.v1.JobService
 */
export const JobService: GenService<{
  /**
   * ListJobs returns jobs newest-first, optionally scoped to one city.
   *
   * @generated from rpc travplaces.v1.JobService.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof ListJobsRequestSchema;
    output: typeof ListJobsResponseSchema;
  },
  /**
   * GetJob returns one job by id.
   *
   * @generated from rpc travplaces.v1.JobService.GetJob
   */
  getJob: {
    methodKind: "unary";
    input: typeof GetJobRequestSchema;
    output: typeof GetJobResponseSchema;
  },
  /**
   * CancelJob cancels a queued or running job.
   *
   * @generated from rpc travplaces.v1.JobService.CancelJob
   */
  cancelJob: {
    methodKind: "unary";
    input: typeof CancelJobRequestSchema;
    output: typeof CancelJobResponseSchema;
  },
  /**
   * EnqueueImportOsm queues an OSM extract download for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueImportOsm
   */
  enqueueImportOsm: {
    methodKind: "unary";
    input: typeof EnqueueImportOsmRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueImportPois queues a POI import from the city's OSM extract.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueImportPois
   */
  enqueueImportPois: {
    methodKind: "unary";
    input: typeof EnqueueImportPoisRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueImportFsq queues a Foursquare places import for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueImportFsq
   */
  enqueueImportFsq: {
    methodKind: "unary";
    input: typeof EnqueueImportFsqRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueBuildValhalla queues a Valhalla routing-tile build for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueBuildValhalla
   */
  enqueueBuildValhalla: {
    methodKind: "unary";
    input: typeof EnqueueBuildValhallaRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueBuildOtp queues an OTP transit-graph build for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueBuildOtp
   */
  enqueueBuildOtp: {
    methodKind: "unary";
    input: typeof EnqueueBuildOtpRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueBuildBasemap queues a basemap tile build for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueBuildBasemap
   */
  enqueueBuildBasemap: {
    methodKind: "unary";
    input: typeof EnqueueBuildBasemapRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
  /**
   * EnqueueVerify queues a data-verification pass for a city.
   *
   * @generated from rpc travplaces.v1.JobService.EnqueueVerify
   */
  enqueueVerify: {
    methodKind: "unary";
    input: typeof EnqueueVerifyRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_job, 0);

